import React from 'react';

import { Page } from 'components/layouts';

import Connection from 'components/connection';
import Circle from 'components/circle';

import Hero from './hero';
import Video from './video';
import CallToAction from './call-to-action';

import './style.css';

const heroStart = {
  query: '#hero-start-circuit',
  pivot: { x: 0.5, y: 1 },
  offset: { x: 2, y: 0 },
};

const Home = () => {
  return (
    <Page className="page -home">
      <Circle
        className="home-circle"
        width="40%"
        angle={210}
        distance={32}
        blur={16}
      />
      <Connection
        A={heroStart}
        B={{ query: '.home-video-embed' }}
        threshold={{ x: 300, y: 0 }}
      />
      <Connection A={heroStart} B={{ query: '#hero-end-02-circuit' }} />
      <Connection
        A={{ query: '.home-video-embed' }}
        B={{ query: '#video-end-circuit', pivot: { x: 0.5, y: 0 } }}
      />
      <Connection
        A={{ query: '#call-start-circuit', pivot: { x: 0.5, y: 0.8 } }}
        B={{ query: '#call-end-circuit' }}
      />
      <Connection
        A={{ query: '#call-start-02-circuit' }}
        B={{ query: '#call-end-03-circuit' }}
      />
      <Hero />
      <Video />
      <CallToAction />
    </Page>
  );
};

export default Home;
